<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import * as common from "../utiles/common.util";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
    import * as store from "../stores/store";

    export let params;

    const isLocal = typeof window !== "undefined" && (window.location.hostname !== "praimas.asijang.co.kr" && window.location.hostname !== "aspraim.asijang.co.kr");
    const backendBaseUrl = isLocal ? "http://" + window.location.hostname : "https://praimas.asijang.co.kr";
    let rcept_NO = params.rcept_NO;
    let rcept_SN = params.rcept_SN;
    let photo_SE = params.photo_SE;
    let sttus = "";
    let title_text = "작업 전";

    let files = [];
    let previews = [];

    let mobile_CONF_AT = "";

    const rows = 5;
    const cols = 2;
    const totalSlots = rows * cols;

    onMount(() => {
        previews = Array(totalSlots).fill(null);

        getData();
    });

    // 서버 URL → Blob → File → files 배열에 추가
    async function addFilesFromUrls(fileDto, targetList) {
        for (let i = 0; i < fileDto.length; i++) {
            const file = fileDto[i];

            if (file.photo_SE === photo_SE) {
                await addFileFromUrl(file.file_PATH, targetList);
            }
        }
    }

    async function addFileFromUrl(url, targetList) {
        try {
            const fullUrl = url.startsWith("http")
                ? url
                : `${backendBaseUrl}${url}`;

            const response = await fetch(fullUrl);
            const blob = await response.blob();

            // 확장자 유추
            const extension =
                blob.type === "image/png"
                    ? "png"
                    : blob.type === "image/jpeg"
                      ? "jpg"
                      : "bin";

            const file = new File([blob], `image_from_url.${extension}`, {
                type: blob.type,
            });

            const previewUrl = URL.createObjectURL(file);

            const emptyIndex = previews.findIndex(
                (p) => p === null || p === undefined
            );
            if (emptyIndex !== -1) {
                previews[emptyIndex] = previewUrl;
                targetList[emptyIndex] = file;
            } else if (previews.length < totalSlots) {
                previews.push(previewUrl);
                targetList.push(file);
            }
        } catch (error) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("URL 이미지 변환 실패:", error);
        }
    }

    function handleFiles(event) {
        const newFiles = Array.from(event.target.files);
        if (newFiles.length === 0) return;

        newFiles.forEach((file) => {
            const previewUrl = URL.createObjectURL(file);
            // 빈 슬롯 먼저 찾기
            const emptyIndex = previews.findIndex(
                (p) => p === null || p === undefined
            );
            if (emptyIndex !== -1) {
                previews[emptyIndex] = previewUrl;
                files[emptyIndex] = file;
            } else if (previews.length < totalSlots) {
                previews.push(previewUrl);
                files.push(file);
            } else {
                // [디버그 로그] 로직과 무관, 슬롯 초과 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
                console.warn("더 이상 업로드할 수 없습니다.");
            }
        });

        event.target.value = "";
    }

    function deleteOne(index) {
        if (previews[index]) {
            URL.revokeObjectURL(previews[index]);
        }

        // 삭제 후 새로운 배열 만들어서 할당 (reactivity 보장)
        files = files.filter((_, i) => i !== index);
        previews = previews
            .filter((_, i) => i !== index)
            .concat(Array(totalSlots - (previews.length - 1)).fill(null));
    }

    function clearAll() {
        previews.forEach((src) => src && URL.revokeObjectURL(src));
        files = [];
        previews = Array(totalSlots).fill(null);
    }

    function updatePreview() {
        // 강제로 반응성 트리거
        previews = [...previews];
        files = [...files];
    }

    // 칸씩 나누기
    $: chunked = [];
    $: {
        chunked = [];
        for (let i = 0; i < totalSlots; i += cols) {
            chunked.push(previews.slice(i, i + cols));
        }
    }

    async function getData() {
        const response = await api.get(
            `/as/${rcept_NO}?RCEPT_SN=${rcept_SN}&PHOTO_SE=${photo_SE}`
        );

        if (response != null) {
            const data = response.data;

            mobile_CONF_AT = data.mobile_CONF_AT;
            sttus = data.sttus;

            if (photo_SE == "2") {
                title_text = "작업 후";
            }

            await addFilesFromUrls(response.searchVO, files);
            updatePreview();
        }
    }

    async function saveClick() {
        const formData = new FormData();
        formData.append("RCEPT_NO", rcept_NO);
        formData.append("RCEPT_SN", rcept_SN);
        formData.append("PHOTO_SE", photo_SE);

        files.forEach((file) => {
            formData.append("multipartFile", file);
        });

        const response = await api.post(`/file/put`, formData);

        if (response != null) {
            alert("이미지 업로드 완료");
            push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
        }
    }

    function goBack() {
        push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
    }

    // 페이지가 로드될 때 goBack 등록
    store.currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        store.currentGoBack.set(null);
    });
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<section class="main inner main-gray" style="width: 100%; position: relative;">
    <div class="mobile">
        <div style=" background: #FFF;">
            <div
                class="cmn-title-left gray-width"
                style="padding-top: 20px; padding-bottom: 15px;"
            >
                <p>{title_text} 이미지 업로드</p>
            </div>

            <div class="bcnc-dtl" style="width: 90%; margin: auto;">
                <div class="bcnc-dtl-in">
                    <div class="dtl-file">
                        <p class="dtl-title">{title_text} 이미지</p>
                        <input
                            type="file"
                            id="input-file"
                            class="input-file"
                            accept="image/*"
                            multiple
                            on:change={handleFiles}
                        />

                        <label
                            class="btn-file"
                            for="input-file"
                            style="right: 75px;"
                        >
                            파일 추가 +
                        </label>

                        <label class="btn-file" on:click={clearAll}>
                            전체 삭제
                        </label>
                    </div>

                    <div class="img-wrap">
                        {#each chunked as row, rowIndex}
                            <ul>
                                {#each row as src, colIndex}
                                    <li>
                                        <img
                                            src={src ??
                                                "../resource/img/img_none.png"}
                                            alt="preview"
                                        />
                                        {#if src}
                                            <img
                                                src="../resource/img/ico_delete_.png"
                                                class="img_del"
                                                on:click={() =>
                                                    deleteOne(
                                                        rowIndex * cols +
                                                            colIndex
                                                    )}
                                            />
                                        {/if}
                                    </li>
                                {/each}
                            </ul>
                        {/each}
                    </div>
                </div>
            </div>

            <div class="cmn-btn cmn-btn-btm">
                <button
                    on:click={() => {
                        saveClick();
                    }}
                >
                    이미지 업로드
                </button>
            </div>
        </div>
    </div>
</section>
